function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import draggable from 'vuedraggable';
import { getSalary, getSalaryContent, putSalaryContent, latelySalaryContent } from '@/api/enterprise';
export default {
  name: '',
  components: {
    draggable: draggable
  },
  props: {
    id: {
      type: [String, Number, Boolean],
      default: function _default() {
        return false;
      }
    },
    editForm: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      unmodifiedFormItem: [],
      dialogVisible: false,
      mark: '',
      title: '定薪',
      status: 'add',
      loading: false,
      take_date: '',
      fromItem: [{
        label: '基本工资(元):',
        value: '0',
        placeholder: '请输入基本工资',
        sort: 1
      }, {
        label: '绩效工资(元):',
        value: 0,
        placeholder: '请输入绩效工资',
        sort: 2
      }, {
        label: '岗位工资(元):',
        value: 0,
        placeholder: '请输入岗位工资',
        sort: 3
      }, {
        label: '管理津贴(元):',
        value: 0,
        placeholder: '请输入管理津贴',
        sort: 4
      }, {
        label: '技能补贴(元):',
        value: 0,
        placeholder: '请输入基本工资',
        sort: 5
      }, {
        label: '其他补贴(元):',
        value: 0,
        placeholder: '请输入餐饮，交通，话费，电脑等其他补贴',
        sort: 6
      }],
      time: '',
      rules: [],
      total: 0,
      salaryId: '',
      type: '',
      nowtype: ''
    };
  },
  created: function created() {
    var nowDate = new Date();
    var date = {
      year: nowDate.getFullYear(),
      month: nowDate.getMonth() + 1,
      day: nowDate.getDate()
    };
    var dayDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + date.day;
    this.take_date = dayDate;
  },
  methods: {
    show: function show() {
      this.dialogVisible = true;
    },
    handleResetFn: function handleResetFn() {
      this.fromItem = JSON.parse(JSON.stringify(this.unmodifiedFormItem));
      if (this.nowtype == '调薪弹窗') {
        this.title = '调薪弹窗';
        this.status = 'add';
        this.type = '调薪弹窗';
      } else {
        // this.title = '编辑薪资'
        this.status = 'add';
      }
    },
    restFn: function restFn() {
      this.dialogVisible = false;
      this.fromItem.forEach(function (item) {
        item.value = 0;
      });
      this.nowtype = '';
    },
    blurVal: function blurVal(data, index) {
      this.fromItem[index].value = data.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1');
    },
    handleInput: function handleInput(data, index) {
      this.fromItem[index].value = data.replace(/\D/g, '').replace(/^0{1,}/g, '');
    },
    // 单独编辑
    editId: function editId(val) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.status = 'add';
              _this.title = val.title;
              _this.salaryId = val.id;
              _context.next = 5;
              return getSalaryContent(val.id);
            case 5:
              result = _context.sent;
              _this.mark = result.data.mark;
              _this.take_date = result.data.take_date;
              _this.fromItem = result.data.content;
              _this.dialogVisible = true;
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 调薪弹窗
    changeSalary: function changeSalary(val) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var result, i;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.title = val.title;
              _this2.status = 'add';
              _this2.type = '调薪弹窗';
              _this2.nowtype = '调薪弹窗';
              _context2.next = 6;
              return latelySalaryContent(_this2.id);
            case 6:
              result = _context2.sent;
              _this2.mark = result.data.mark;
              _this2.take_date = result.data.take_date;
              _this2.fromItem = result.data.content;
              // 添加新属性
              for (i = 0; i < _this2.fromItem.length; i++) {
                _this2.fromItem[i].num = _this2.fromItem[i].value;
              }
              //  绑定值置空
              _this2.fromItem.forEach(function (item) {
                item.value = '';
              });
              _this2.dialogVisible = true;
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 编辑
    editFn: function editFn() {
      this.unmodifiedFormItem = JSON.parse(JSON.stringify(this.fromItem));
      this.title = '编辑表单字段';
      this.status = 'edit';
    },
    // 拖动
    onStart: function onStart() {
      this.drag = true;
    },
    onEnd: function onEnd() {
      this.drag = false;
    },
    // 删除动态表单
    handleDelete: function handleDelete(index) {
      this.fromItem.splice(index, 1);
    },
    // 添加动态表单
    handleAddType: function handleAddType() {
      if (this.fromItem.length > 0) {
        var status = this.fromItem.some(function (el, index) {
          return el.label === '';
        });
        if (status) {
          this.$message.warning(this.$t('customer.message05'));
        } else {
          this.fromItem.push({
            sort: '',
            value: 0,
            label: '',
            placeholder: '请输入'
          });
        }
      } else {
        this.fromItem.push({
          sort: '',
          value: 0,
          label: '',
          placeholder: '请输入'
        });
      }
    },
    // 提交表单
    okFn: function okFn() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var totalArr, newtol, data;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              totalArr = [];
              _this3.fromItem.forEach(function (item) {
                totalArr.push(item.value);
              });
              newtol = totalArr.map(Number);
              _this3.total = newtol.reduce(function (x, y) {
                return x + y;
              });
              data = {
                take_date: _this3.take_date,
                card_id: _this3.id,
                total: _this3.total,
                content: _this3.fromItem,
                mark: _this3.mark
              };
              _this3.loading = true;
              if (!(_this3.title == '编辑薪资')) {
                _context3.next = 15;
                break;
              }
              _context3.next = 9;
              return putSalaryContent(_this3.salaryId, data);
            case 9:
              _context3.next = 11;
              return _this3.$emit('getSalaryList');
            case 11:
              _this3.dialogVisible = false;
              _this3.loading = false;
              _context3.next = 22;
              break;
            case 15:
              _context3.next = 17;
              return getSalary(data);
            case 17:
              _this3.dialogVisible = false;
              _context3.next = 20;
              return _this3.$emit('getSalaryList');
            case 20:
              _this3.loading = false;
              _this3.fromItem.forEach(function (item) {
                item.value = '0';
              });
            case 22:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    // 确定动态表单
    handleConfirm: function handleConfirm() {
      var _this4 = this;
      var data = [];
      if (this.fromItem.length <= 0) {
        this.$message.warning(this.$t('customer.message05'));
      } else {
        var status = this.fromItem.some(function (el, index) {
          return el.label === '';
        });
        if (status) {
          this.$message.warning(this.$t('customer.message05'));
        } else {
          var len = this.fromItem.length;
          this.fromItem.map(function (value, index) {
            if (_this4.type == '调薪弹窗') {
              data.push({
                label: value.label,
                value: '',
                num: 0,
                sort: len - index + 1,
                placeholder: value.placeholder + value.label
              });
            } else {
              data.push({
                label: value.label,
                value: value.value,
                sort: len - index + 1,
                placeholder: value.placeholder + value.label
              });
            }
          });
          this.status = 'add';
          if (this.type == '调薪弹窗') {
            this.title = '调薪弹窗';
          }
        }
      }
    }
  }
};